module.exports = __webpack_public_path__ + "assets/dienst.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/documentation/images/dienst.jpg
// module id = 356
// module chunks = 0